import { IDocumentFileModel, IUploadFileForm } from '@api/models';
import useMultipartUpload from './useUploadMultiPart';

interface AddDocumentOptions {
    clientId: string;
    onAdd: (file: IDocumentFileModel) => void;
}

const useAddDocumentForm = (options: AddDocumentOptions) => {
    const { onAdd, clientId } = options;

    const config = {
        chunkSize: 200 * 1024 * 1024,
        maxConcurrentUploads: 3,
    };

    const multipartUpload = useMultipartUpload({
        clientId,
        onAdd,
        config,
    });

    const initialValues: IUploadFileForm = {
        files: [],
        name: '',
        users: [],
        folderId: null,
    };

    const submit = async (values: IUploadFileForm) => {
        await multipartUpload.submit({
            files: values.files,
            name: values.name,
            folderId: values.folderId || '',
            users: values.users,
        });
    };

    return {
        isInitializing: multipartUpload.isInitializing,
        isLoading: multipartUpload.isLoading,
        initialValues,
        submit,
    };
};

export default useAddDocumentForm;
